import { FC } from 'react';
import image from '../../assets/page-not-found.svg';
import { PageNotFoundProps } from './PageNotFound.types';

const PageNotFound: FC<PageNotFoundProps> = () => <img src={image} alt='page-not-found' />;

export default PageNotFound;
